module.exports = __webpack_public_path__ + "img/IMG_1349.928a1390.png";